const redirectSignIn = [
    "http://localhost:3000/oauth-callback",
    "https://dev.dnxdi4o7g3ky3.amplifyapp.com/oauth-callback",
    "https://devapp.animotive.com/oauth-callback",
    "https://app.animotive.com/oauth-callback",
];

const redirectSignOut = [
    "http://localhost:3000/signout",
    "https://dev.dnxdi4o7g3ky3.amplifyapp.com/signout",
    "https://devapp.animotive.com/signout",
    "https://app.animotive.com/signout",
];

const awsconfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_USER_POOL_ID,
            userPoolClientId: process.env.REACT_APP_CLIENT_SECRET,
            loginWith: {
                oauth: {
                    domain: "retinize.auth.eu-west-2.amazoncognito.com",
                    scopes: ["aws.cognito.signin.user.admin", "email", "openid", "profile"],
                    redirectSignIn,
                    redirectSignOut,
                    responseType: "code",
                },
            },
        },
    },
};

export default awsconfig;
